import "whatwg-fetch";
import Immutable from "immutable";
import { getDomainWebchat, getDomainWebchatInNewChannel } from "utils";
import { objectToQueryParams } from "fe-shared/utils/urlUtils";

const global = { token: null };
const errorCodes = [204, 404];

export function setTokenForAPI(token) {
  global.token = token;
}

export function getToken() {
  return global.token;
}

function parseJSON(response) {
  return new Promise(resolve => {
    const { status } = response;
    if (errorCodes.includes(status)) {
      resolve({ data: null, status: response.status });
      return;
    }

    if (status >= 500) {
      resolve({
        data: ["Connection failed. Try again in a few seconds, please."],
      });
      return;
    }

    response.json().then(data => resolve({ data, status: response.status }));
  });
}

function makeImmutable(response) {
  return Immutable.fromJS(response.data);
}

const checkStatusFn = sentData => response => {
  if (!(response.status >= 200 && response.status < 300)) {
    const error = new Error(response.status);
    error.status = response.status;
    error.data = makeImmutable(response);
    error.sentData = Immutable.fromJS(sentData);
    throw error;
  }
  return response;
};

const errors =
  sentData =>
  ({ status, data }) => {
    const error = {
      status,
      data,
      sentData,
    };
    throw error;
  };

export function makeRequester(url, options = {}) {
  const { method = "GET", headers = {}, queryParams = {} } = options;
  return ({ data, id = "" } = {}) => {
    let mergedUrl = `${getDomainWebchat()}`;
    if (data) {
      const { newChannel } = data;
      if (newChannel) {
        mergedUrl = `${getDomainWebchatInNewChannel()}`;
      }
    }
    mergedUrl = `${mergedUrl}${url}${id}`;
    if (mergedUrl.substr(-1) !== "/") {
      mergedUrl += "/";
    }

    mergedUrl = `${mergedUrl}?${objectToQueryParams(queryParams)}`;

    const token = getToken();

    const newHeaders = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? `JWT ${token}` : null,
      ...headers,
    };

    let body = JSON.stringify(data);

    if (method === "GET" || method === "HEAD") {
      body = undefined;
    }

    return fetch(mergedUrl, {
      method,
      headers: newHeaders,
      body,
    })
      .then(parseJSON)
      .then(checkStatusFn(data))
      .then(makeImmutable)
      .catch(errors(data));
  };
}

export default {
  makeRequester,
  setTokenForAPI,
  getToken,
};
